<template>
    <b-container fluid>
        <b-table
            :id="id"
            primary-key="inventory_id"
            bordered
            striped
            hover
            caption-top
            show-empty
            sort-desc
            sort-by="state_datetime"
            stacked="sm"
            :fields="inventoryTableFields"
            :items="filteredItems"
            :filter="filter"
        >
            <template v-slot:empty="">
                <span>No Inventory data available.</span>
            </template>

            <!-- <template v-slot:cell(fice)="row">
                <div v-b-popover.hover.bottom="row.item.lea">
                    {{ row.item.fice }}
                </div>
            </template> -->

            <!-- <template v-slot:cell(cost_type)="row">
                <div v-b-popover.hover.bottom="costTypeLookup(row.item.cost_type).description">
                    {{ row.item.cost_type }}
                </div>
            </template> -->

            <!-- <template v-slot:cell(item_qty)="row">
                {{ row.item.quantity }} @ {{ displayAsMoney(row.item.unit_cost) }}/ea
            </template>

            <template v-slot:cell(total)="row">
                {{ displayAsMoney(row.value) }}
            </template>

            <template v-slot:cell(funds_perkins)="row">
                {{ displayAsMoney(row.value) }}
            </template> -->
            <template v-slot:cell(_actions)="row">
                <b-form-row>
                    <b-col>
                        <b-button
                            v-b-popover.hover.bottom="'Click here to view more details about this inventory item.'"
                            class="edit-button"
                            size="sm"
                            @click.stop="modalView(row.item, row.index, $event.target)"
                        >
                            <fa-icon fixed-width size="lg" :icon="['fas', 'info-circle']" />
                        </b-button>

                        <b-button
                            v-if="isReviewer"
                            v-b-popover.hover.top="'Click here to edit this inventory entry.'"
                            class="edit-button"
                            size="sm"
                            @click.stop="modalEdit(row.item, row.index, $event.target)"
                        >
                            <fa-icon fixed-width size="lg" :icon="['fal', 'pencil']" />
                        </b-button>
                    </b-col>
                </b-form-row>
            </template>
            <!-- @click.stop="modalEdit(row.item, row.index, $event.target)" -->
            <!-- <template v-slot:row-details="row">
                <slot name="inventory-details">
                    <inventory-detail
                        :id="row.index"
                        :inventory-id="row.item.inventory_id"
                    />
                    {{ row }}
            </slot> -->
        </b-table>

        <inventoryModal :modal-visible.sync="inventoryModalVisible"
                        :form-disabled="modalLocked"
                        :inventory-modal-data.sync="inventoryModalData"
        />
    </b-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { Arc } from '$Shared/@arc/vue-arc';
// import { alertManager as AlertManager } from '@/plugins/alertManager';

const inventoryTableFields = [
    {
        key: 'purchase_ay',
        label: 'AY',
        sortable: true,
        // formatter: (value) => '20' + value
    },
    // {
    //     key: 'fice',
    //     label: 'Inst.',
    //     sortable: true,
    // },
    {
        key: 'description',
        label: 'Description',
        sortable: true
    },
    {
        key: 'location',
        label: 'Location',
        sortable: true
    },
    {
        key: 'serial',
        label: 'Serial',
        sortable: true
    },
    {
        key: 'model',
        label: 'Model',
        sortable: true
    },
    {
        key: 'inventory_tag',
        label: 'Tag',
        sortable: true
    },
    {
        key: '_actions',
        label: 'Actions',
        class: 'actions-header',
        sortable: false
    },
];

export default {
    name: 'InventoryListTable',

    components: {
        // 'inventory-detail': InventoryDetail,
    },

    props: {
        id: { type: String, default: 'inventory-list-table' },
        lea: { type: String, required: true },
        currentAy: { type: String, required: true },
        rows: { type: Array, default: null },
        formDisabled: { type: Boolean, default: true },
        columns: { type: Array, default: null },
        caption: { type: String, default: null },
        filter: { type: String, default: null },
        aySelect: { type: [String, Number], default: null },
    },

    data() {
        return {
            inventoryTableFields,
            isSaving: false,
            inventoryModalVisible: false,
            inventoryModalData: {},
            modalLocked: true,
        };
    },

    computed: {
        ...mapGetters({
            inventoryItems: 'inventory/inventoryItems',
            isAdmin: 'auth/isAdmin',
            isReviewer: 'auth/isReviewer',
            ficeCodeShortName: 'ref/ee/ficeShortName',
            isAuthorized: 'auth/isAuthorized',
            ficeName: 'ref/ee/ficeName'
        }),

        inventoryTableItems() {
            return this.inventoryItems.map(item => {
                return {
                    ...item,
                    // purchaseId: item.purchase_id,
                    // costId: item.cost_id,
                    description: item.description,
                    model: item.model,
                    serial: item.serial,
                    location: item.location,
                    // purchaseDate: item.purchase_date,
                    ay: item.purchase_ay,
                    // lea: this.lea,
                    // fice: this.ficeCodeShortName(this.lea),
                    // _showDetails: false,
                };
            });
        },

        editButtonTooltip() {
            return !this.isReviewer
                ? 'Click here to view more details about this inventory item.'
                : 'Click here to edit this inventory entry.';
        },

        editButtonIcon() {
            return !this.isReviewer ? ['fas', 'info-circle'] : ['fal', 'pencil'];
        },

        isAdminButton() {
            let show = false;
            if (this.isReviewer) {
                show = true;
            }
            return show;
        },

        applicantName() {
            return this.ficeName(this.lea || null);
        },

        filteredItems() {
            return (this.aySelect)
                ? this.inventoryTableItems.filter((item) =>
                    Number(item.purchase_ay) ===
                    Number(this.aySelect))
                : this.inventoryTableItems;
        },
    },

    async created() {
        await this.$store.dispatch('ref/ee/fetchRefEe', this.currentAy);
        await this.fetchInventoryItems(this.lea);
    },

    methods: {
        ...mapActions({
            fetchInventoryItems: 'inventory/fetchInventoryItems',
            fetchRefEe: 'ref/ee/fetchRefEe',
        }),

        displayAsMoney(value) {
            return Arc.Money.asCurrency(value);
        },

        modalView(item) {
            this.inventoryModalData = {
                ...this.inventoryTableItems.find(
                    inventory => item.inventory_id === inventory.inventory_id
                )
            };
            this.modalLocked = true;
            this.inventoryModalVisible = true;
        },

        modalEdit(item) {
            this.inventoryModalData = {
                ...this.inventoryTableItems.find(
                    inventory => item.inventory_id === inventory.inventory_id
                )
            };

            this.modalLocked = false;
            this.inventoryModalVisible = true;
        },
        // modalAdd() {
        //     this.inventoryModalData = null;
        //     this.inventoryModalVisible = true;
        // },

        onShowPopover(targetID, idx) {
            this.$root.$emit('bv::show::popover', targetID);
        },

        onClosePopover() {
            this.$root.$emit('bv::hide::popover');
        },

        onDeleteOk(rowItem) {
            this.$store.dispatch('inventory/deleteInventoryItem', rowItem);
            this.$root.$emit('bv::hide::popover');
        },

        onFiltered(event) {
            this.$emit('filtered', event);
        },

        onRowClicked(event) {
            this.$emit('row-clicked', event);
        },
    },
};
</script>

<style lang="scss">
@import "$StyleVars";

$action-button-width: 41.31px;

.show-table-button {
    color: #ffffff;
    font-weight: bold;
    background-color: #006438;
    border: 0;
    border-radius: 0.45rem;
    box-shadow: 0 2px 5px gray;

    &:hover {
        background-color: #003f23;
        box-shadow: 0 0 4px 3px #9f9f9f;
    }
}

.inventory-card-style {
    border: 0;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
}

.inventory-header {
    background: #380064;
    color: #ffffff;
    font-size: 1.5rem;
    font-weight: bolder;
    /* text-transform: uppercase;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    text-transform: uppercase; */
}

.shadow {
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.active-table-row {
    background-color: #dae2ce;
}

.rounded-button {
    border-radius: 5px;
    color: #ffffff;
    font-weight: bold;
    background-color: #006438;
    border: 0;
    box-shadow: 0 2px 5px gray;

    &:hover,
    &:focus {
        background-color: #00311c;
    }

    &:active {
        color: #ffffff;
        font-weight: bolder;
        border-radius: 5px 5px 0 0;

        background: rgb(109, 140, 57);
        background: linear-gradient(
            180deg,
            rgba(109, 140, 57, 1) 0%,
            rgba(109, 140, 57, 0.75) 50%
        );
    }
}

.cancel-button {
    color: #00000090;
}

.cancel-button:hover {
    color: #00000090;
    border-color: #7d7d7d;
    border-radius: 0.25rem;
    background-color: #00000015;
}

.page-link {
    margin-left: -1px;
    font-weight: bold;
    line-height: 1.25;
    color: #006438;
    border: 1px dotted gray;
}

.page-item.active .page-link {
    font-weight: bold;
    color: #fff;
    background-color: #006438;
    border: 1px solid white;
}

.table {
    tbody {
        td {
            .itemTitle {
                position: relative;
                width: auto;

                &:before {
                    content: attr(title);
                    width: auto;
                    max-width: 100%;
                    overflow: hidden;
                    position: absolute;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }

    .actions-column .col {
        padding-left: 0;
        padding-right: 0;
        white-space: nowrap;

        .action-placeholder {
            width: $action-button-width;
        }
    }
}

.submit-button,
.budget-button,
.delete-button {
    background-color: #ffffff00;
    border-color: #ffffff00;
    font-weight: bold;

    &:hover {
        border-radius: 0.25rem;
    }
}

.submit-button {
    color: $submit-button-color;

    &:hover {
        background-color: scale_color($submit-button-color, $alpha: 8%);
        border-color: $submit-button-color;
    }
}

.budget-button {
    color: $budget-button-color;

    &:hover {
        background-color: scale_color($budget-button-color, $alpha: 8%);
        border-color: $budget-button-color;
    }
}

.delete-button {
    color: $delete-button-color;

    &:hover {
        background-color: scale_color($delete-button-color, $alpha: 8%);
        border-color: $delete-button-color;
    }
}
</style>
